import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useI18n } from '../../context/occ/hooks/use-i18n';
import { CensorRatingIcon } from '../censor-rating-icon/censor-rating-icon';
const b = bemClassBuilder('v-film-title');
export const FilmTitle = observer(props => {
    const { as: Title, film, censorRating, censorRatingIconCdnOptions } = props;
    const i18n = useI18n();
    const filmTitle = i18n.translatable(film.title);
    return (_jsxs("div", { className: b.block(), children: [_jsx(Title, { className: b.element('text'), children: filmTitle }), censorRating && (_jsx(CensorRatingIcon, { className: b.element('censor-rating'), censorRating: censorRating, cdnOptions: censorRatingIconCdnOptions }))] }));
});
FilmTitle.displayName = 'FilmTitle';
export const FilmTitleSkeleton = () => _jsx("div", { className: b.block({ skeleton: true }) });
FilmTitleSkeleton.displayName = 'FilmTitleSkeleton';
//# sourceMappingURL=film-title.js.map